import script from "./config-tags.vue?vue&type=script&lang=tsx&setup=true"
export * from "./config-tags.vue?vue&type=script&lang=tsx&setup=true"

import "./config-tags.vue?vue&type=style&index=0&id=3615ab28&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3615ab28"]])

export default __exports__